import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  pt: (p) => p.spacing(6.5),
};

export const box: SxStyle = {
  padding: (p) => p.spacing(2, 5, 2, 5),
  backgroundColor: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(1.5),
  width: '100%',
};
